import React from "react"
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import { Box, TextField, Typography, Button, Select, MenuItem, InputLabel, FormControl, Snackbar, Alert, Chip, Menu, Skeleton } from "@mui/material"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Switch from '@mui/material/Switch';
import { prepareJSON } from "../../../utils/prepareJSON";
import { useSelector } from "react-redux";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { logOut } from "../../../utils/logOut";
import DeleteIcon from '@mui/icons-material/Delete';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import TranslatedText from "../../../utils/Translate"
import { languageOptions, clientLanguageOptions } from "../../../utils/LanguageList";
import { clearContactData, getContactData } from "../../../store/webcall/webCallReducer";
import { useSnackbar } from "../../../utils/SnackbarContext";
import { DateTimePicker } from "@mui/x-date-pickers";


export default function Contact() {
    //Get params from url
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Declaration states
    const [loading, setLoading] = useState(false)
    const [loadContactGroups, setLoadContactGroups] = useState(false)

    dayjs.extend(utc);
    dayjs.extend(timezone);

    // Задаём дефолтную зону
    dayjs.tz.setDefault('Europe/Moscow');

    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [openCallSnackbar, setCallSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])
    const [contactGroupContacts, setContactGroupContacts] = useState([])
    const [contactGroups, setContactGroups] = useState([])
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [channels, setChannels] = useState([])
    const [users, setUsers] = React.useState([]);
    const [documentReportData, setDocumentReport] = useState<any>(
        {
            "channel": null,
            "documentreport": null,
        }
    )
    const [contactData, setContactData] = useState<any>(type === 'edit' ? [] :
        {
            "id": null,
            "lastname": null,
            "firstname": null,
            "middlename": null,
            "user": localStorage.getItem('id') ? localStorage.getItem('id') : null,
            "mobilephone": null,
            "homephone": null,
            "businessphone": null,
            "product": null,
            "leaddate": null,
            "datetocontact": null,
            "notes": null,
            "city": null,
            "dateofexport": null,
            "email": null,
            "marketingcampaign": null,
            "promotionalcode": null,
            "postalcode": null,
            "country": null,
            "oblast": null,
            "region": null,
            "street": null,
            "house": null,
            "building": null,
            "flat": null,
            "partnerbank": null,
            "cgnote": null,
            "isclosed": "0",
            "blacklist": "0",
            "cgdatetoprocess": null,
            "leadtype": null,
            "motivationamount": null,
            "bankmotivationamount": null,
            "cardnumber": null,
            "chargemotivation": null,
            "conversationtemplate": null,
            "clientid": null,
            "timezone": "0",
            "birthday": null,
            "sex": "0",
            "additionalfields": null,
            "temp_additionalfields": null,
            "language_client": null,
            "language_translation": null,
            'channel': null,
            'customerleadid': id
        }
    )
    const dispatch = useAppDispatch()

    const { showSnackbar } = useSnackbar();
    //Set header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit contact` : 'Add contact'))
    }, [dispatch]);


    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )
    //Getting data when loading a component, depending on the parameters
    useEffect(() => {
        type === 'edit' && fetchData()
        accesslevel === "5" && getPartners()
        getConversationtemplates()
        getUsers()
        getChannels()
        type === 'edit' && getContactGroupsContact({ leadid: id })
        getContactGroups()
        return () => {
            dispatch(clearContactData());
        };
    }, [])

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleCloseCall = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setCallSnackbar(false);
    };

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleAddContactToGroup = async (groupId: any) => {
        handleMenuClose()
        await postContactToGroup({
            "leadid": id,
            "leadgroupid": groupId
        })

        getContactGroupsContact({ leadid: id })


    };
    //add contact to group
    async function postContactToGroup(data: object = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/contactgroupscontacts`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    async function deleteContactFromGroup(contactGroupContactid: any) {
        try {
            const response = await axios.delete('https://cardgarantsales.com/restapi/contactgroupscontacts/' + contactGroupContactid, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })
            getContactGroupsContact({ leadid: id })
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Making request to get current contact data
    async function fetchData(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/contact/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            setContactData(response.data[0])
            // dispatch(getContactData(response.data[0]))
            setContactData({ ...response.data[0], additionalfields: prepareJSON(response.data[0].additionalfields), leaddate: response.data[0].leaddate, birthday: response.data[0].birthday, datetocontact: response.data[0].datetocontact, cgdatetoprocess: response.data[0].cgdatetoprocess })
            setLoading(false)
            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }
    //Making request to get partners list
    async function getPartners(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setSPartners(response.data)

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }

    //Making request to get channels list
    async function getChannels(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/channelselector`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setChannels(response.data)

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }
    //Making request to get ContactGroupContact list
    async function getContactGroupsContact(params: object = {}) {
        // setLoadContactGroups(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/contactgroupscontacts`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setContactGroupContacts(response.data)

            // setLoadContactGroups(false)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            // setLoadContactGroups(false)
        }
    }
    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setConversationtemplates(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get contact groups for Select field
    async function getContactGroups(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/contactgroup`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setContactGroups(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Making request to get users list
    async function getUsers(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/user`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setUsers(response.data)
            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }
    //Making request to create contact
    async function postData(data: object = {}) {
        setLoading(true)
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/contact`, {
                ...data,
                birthday: contactData.birthday ? contactData.birthday : null,
                leaddate: contactData.leaddate ? contactData.leaddate : null,
                datetocontact: contactData.datetocontact ? contactData.datetocontact : null,
                cgdatetoprocess: contactData.cgdatetoprocess ? contactData.cgdatetoprocess : null
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setLoading(false)
            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }

    async function makeCall(data: object = {}) {
        setLoading(true)
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/makecall`, {
                ...data,
                'customerleadid': id
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            if (response.data !== null && typeof response.data == 'string') {
                if (response.data.trim().length != 0) {
                    setSnackbarType('error')
                    setCallSnackbar(true)
                }
                else {
                    setSnackbarType('success')
                    setCallSnackbar(true)
                }

            }

            setLoading(false)
        } catch (error: any) {
            setSnackbarType('error')
            setCallSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }

    const checkDate = (el: any) => {
        if (el !== null && typeof (el) !== "string") {
            if (el.isValid()) {
                return true
            }
        }
        else return false
    }
    //Making request to update contact
    async function putData(data: object = {}) {
        setLoading(true)

        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/contact/${id}`, {
                ...contactData,
                birthday: contactData.birthday || null,
                leaddate: contactData.leaddate || null,
                datetocontact: contactData.datetocontact || null,
                cgdatetoprocess: contactData.cgdatetoprocess || null
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setLoading(false)
            setSnackbarType('success')
            setOpenSnackbar(true)
        }
        catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }

    useEffect(() => {
        if (contactData.length !== 0 && type === 'edit') {
            dispatch(getContactData({
                ...contactData,
                birthday: contactData.birthday || null,
                leaddate: contactData.leaddate || null,
                datetocontact: contactData.datetocontact || null,
                cgdatetoprocess: contactData.cgdatetoprocess || null
            }))
        }
    }, [contactData]);


    return (
        <>
            {

                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Box>
                        <Box sx={{ width: 940, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                            {Number(accesslevel) === 5 &&
                                <>
                                    {/* <TextField error={contactData.partnerbank === null} onChange={(e) => setContactData({ ...contactData, partnerbank: e.target.value !== '' ? e.target.value : null })} value={contactData.partnerbank || ''} variant="outlined" size="small" label='Partner*' /> */}
                                    <FormControl>
                                        <InputLabel sx={{ color: contactData.partnerbank === '' || contactData.partnerbank === null ? "#d32f2f" : "#666666" }} size="small" id="simple-select-label"><TranslatedText text={'Partner'} />*</InputLabel>
                                        <Select error={contactData.partnerbank === '' || contactData.partnerbank === null} sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setContactData({ ...contactData, partnerbank: e.target.value !== '' ? e.target.value : null })} value={contactData.partnerbank || ''} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                                            {
                                                partners.map((el: any) => {
                                                    //make partners list item
                                                    return (
                                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                    {/* <TextField error={contactData.user === null} onChange={(e) => setContactData({ ...contactData, user: e.target.value !== '' ? e.target.value : null })} value={contactData.user || ''} variant="outlined" size="small" label='Operator*' /> */}

                                </>
                            }
                            <select style={{ fontSize: 16, padding: "10px 10px", borderColor: contactData.user !== null ? "#c4c4c4" : "#d32f2f", borderRadius: 5, width: '223px', color: contactData.user === null ? "#d32f2f" : '#000' }} onScroll={() => console.log(123)
                            } onChange={(e) => setContactData({ ...contactData, user: e.target.value !== '' ? e.target.value : null })} value={contactData.user || ''}  >
                                <option style={{ color: '#000' }} value={""}><TranslatedText text={'Operator'} />* (<TranslatedText text={'Not selected'} />)</option>
                                {users.map((el: any) => {
                                    return (
                                        <option style={{ color: "#000" }} key={el.id} value={el.id}>{`${el.partnerbankcode !== null ? `${el.partnerbankcode}-` : ''}${el.lastname} ${el.firstname}`}</option>
                                    )
                                })}
                            </select>
                            <DatePicker label={<span><TranslatedText text={'Lead date'} />*</span>} sx={{ width: 223 }} slotProps={{ textField: { size: 'small' } }} value={contactData.leaddate ? dayjs.tz(contactData.leaddate, 'Europe/Moscow') : null} onChange={(e) => {
                                if (e && !e.isValid()) return;
                                setContactData({ ...contactData, leaddate: e ? e.tz('Europe/Moscow').format('YYYY-MM-DD') : '' });
                            }} format="YYYY-MM-DD" />
                            <TextField key={contactData} error={contactData.clientid === null} onBlur={(e) => setContactData({ ...contactData, clientid: e.target.value !== '' ? e.target.value : null })} defaultValue={contactData.clientid || ''} variant="outlined" size="small" label={<span><TranslatedText text={'Client ID'} />*</span>} />
                            <TextField key={contactData.lastname + 'n'} onBlur={(e) => setContactData({ ...contactData, lastname: e.target.value !== '' ? e.target.value : null })} defaultValue={contactData.lastname || ''} variant="outlined" size="small" label={<TranslatedText text={'Last name'} />} />
                            <TextField key={contactData.firstname + 'f'} onBlur={(e) => setContactData({ ...contactData, firstname: e.target.value !== '' ? e.target.value : null })} defaultValue={contactData.firstname || ''} variant="outlined" size="small" label={<TranslatedText text={'Name'} />} />
                            <TextField key={contactData.middlename + 'm'} onBlur={(e) => setContactData({ ...contactData, middlename: e.target.value !== '' ? e.target.value : null })} defaultValue={contactData.middlename || ''} variant="outlined" size="small" label={<TranslatedText text={'Middle name'} />} />
                            <TextField disabled={type === 'edit' && accesslevel == 3} key={contactData.mobilephone + 'p'} onBlur={(e) => setContactData({ ...contactData, mobilephone: e.target.value !== '' ? e.target.value : null })} defaultValue={contactData.mobilephone || ''} variant="outlined" size="small" label={<span><TranslatedText text={'Mobile phone'} />(<TranslatedText text={'several times'} /> ;)</span>} />
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Timezone'} /></InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setContactData({ ...contactData, timezone: e.target.value !== '' ? e.target.value : null })} value={contactData.timezone || ''} variant="outlined" size="small" label={<TranslatedText text={'Timezone'} />} >
                                    <MenuItem value={""}><TranslatedText text={'Not specified'} /></MenuItem>
                                    <MenuItem value={"-12"}>-12</MenuItem>
                                    <MenuItem value={"-11"}>-11</MenuItem>
                                    <MenuItem value={"-10"}>-10</MenuItem>
                                    <MenuItem value={"-9"}>-9</MenuItem>
                                    <MenuItem value={"-8"}>-8</MenuItem>
                                    <MenuItem value={"-7"}>-7</MenuItem>
                                    <MenuItem value={"-6"}>-6</MenuItem>
                                    <MenuItem value={"-5"}>-5</MenuItem>
                                    <MenuItem value={"-4"}>-4</MenuItem>
                                    <MenuItem value={"-3"}>-3</MenuItem>
                                    <MenuItem value={"-2"}>-2</MenuItem>
                                    <MenuItem value={"-1"}>-1</MenuItem>
                                    <MenuItem value={"0"}>UTC</MenuItem>
                                    <MenuItem value={"1"}>+1</MenuItem>
                                    <MenuItem value={"2"}>+2</MenuItem>
                                    <MenuItem value={"3"}>+3</MenuItem>
                                    <MenuItem value={"4"}>+4</MenuItem>
                                    <MenuItem value={"5"}>+5</MenuItem>
                                    <MenuItem value={"6"}>+6</MenuItem>
                                    <MenuItem value={"7"}>+7</MenuItem>
                                    <MenuItem value={"8"}>+8</MenuItem>
                                    <MenuItem value={"9"}>+9</MenuItem>
                                    <MenuItem value={"10"}>+10</MenuItem>
                                    <MenuItem value={"11"}>+11</MenuItem>
                                    <MenuItem value={"12"}>+12</MenuItem>
                                </Select>
                            </FormControl>
                            <DatePicker label={<TranslatedText text={'Date of birth'} />} sx={{ width: 223 }} slotProps={{ textField: { size: 'small', } }} value={contactData.birthday ? dayjs.tz(contactData.birthday, 'Europe/Moscow') : null} onChange={(e) => {
                                if (e && !e.isValid()) return;
                                setContactData({ ...contactData, birthday: e ? e.tz('Europe/Moscow').format('YYYY-MM-DD') : '' });
                            }} format="YYYY-MM-DD" />
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Sex'} /></InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setContactData({ ...contactData, sex: e.target.value !== '' ? e.target.value : null })} value={contactData.sex || ''} variant="outlined" size="small" label={<TranslatedText text={'Sex'} />} >
                                    <MenuItem value={"0"}><TranslatedText text={'Not specified'} /></MenuItem>
                                    <MenuItem value={"1"}><TranslatedText text={'Male'} /></MenuItem>
                                    <MenuItem value={"2"}><TranslatedText text={'Female'} /></MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Conversation template'} /></InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setContactData({ ...contactData, conversationtemplate: e.target.value !== '' ? e.target.value : null })} value={contactData.conversationtemplate || ''} variant="outlined" size="small" label={<TranslatedText text={'Conversation template'} />} >
                                    {
                                        conversationtemplates.map((el: any) => {
                                            //make conversationtemplate list item
                                            return (
                                                <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <DateTimePicker label={<TranslatedText text={'Desired contact date'} />} sx={{ width: 223 }} slotProps={{ textField: { size: 'small' } }} value={contactData.datetocontact ? dayjs.tz(contactData.datetocontact, 'Europe/Moscow') : null} onChange={(e) => {
                                if (e && !e.isValid()) return;
                                setContactData({ ...contactData, datetocontact: e ? e.tz('Europe/Moscow').format('YYYY-MM-DD HH:mm') : '' });
                            }} format="YYYY-MM-DD HH:mm" />
                            <DateTimePicker label={<TranslatedText text={'Date of the next contact'} />} sx={{ width: 223 }} slotProps={{ textField: { size: 'small' } }} value={contactData.cgdatetoprocess ? dayjs.tz(contactData.cgdatetoprocess, 'Europe/Moscow') : null} onChange={(e) => {
                                if (e && !e.isValid()) return;
                                setContactData({ ...contactData, cgdatetoprocess: e ? e.tz('Europe/Moscow').format('YYYY-MM-DD HH:mm') : '' });
                            }} format="YYYY-MM-DD HH:mm" />
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Status'} /></InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setContactData({ ...contactData, isclosed: e.target.value !== '' ? e.target.value : null })} value={contactData.isclosed || ''} variant="outlined" size="small" label={<TranslatedText text={'Status'} />} >
                                    <MenuItem value={"0"}><TranslatedText text={'Open'} /></MenuItem>
                                    <MenuItem value={"1"}><TranslatedText text={'Closed'} /></MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Client's language"} /></InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setContactData({ ...contactData, language_client: e.target.value !== '' ? e.target.value : null })} value={contactData.language_client || ''} variant="outlined" size="small" label={<TranslatedText text={"Client's language"} />} >
                                    <MenuItem value={""}><TranslatedText text={'Not specified'} /></MenuItem>
                                    {clientLanguageOptions.map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Translation language"} />(<TranslatedText text={"client"} /> -&gt; <TranslatedText text={"robot"} />)</InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setContactData({ ...contactData, language_translation: e.target.value !== '' ? e.target.value : null })} value={contactData.language_translation || ''} variant="outlined" size="small" label={<span><TranslatedText text={"Translation language"} />(<TranslatedText text={"client"} /> -&gt; <TranslatedText text={"robot"} />)</span>} >
                                    <MenuItem value={""}><TranslatedText text={'Not specified'} /></MenuItem>
                                    {languageOptions.map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography><TranslatedText text={'Blacklist'} /> (<TranslatedText text={'do not call'} />)</Typography>
                                <Switch color="error" onChange={(e) => setContactData({ ...contactData, blacklist: contactData.blacklist === '0' ? '1' : '0' })} checked={Boolean(+contactData.blacklist)} />
                            </Box>
                            <TextField key={contactData.notes + '1'} rows={2} onBlur={(e) => setContactData({ ...contactData, notes: e.target.value !== '' ? e.target.value : '' })} defaultValue={contactData.notes || ''} multiline sx={{ width: "100%", '& textarea': { resize: 'vertical' } }} variant="outlined" size="small" label={<TranslatedText text={'Notes'} />} />
                            {Number(accesslevel) === 5 && <TextField key={contactData.cgnote + '2'} rows={2} onBlur={(e) => setContactData({ ...contactData, cgnote: e.target.value !== '' ? e.target.value : '' })} multiline sx={{ width: "100%", '& textarea': { resize: 'vertical' } }} defaultValue={contactData.cgnote || ''} variant="outlined" size="small" label={<TranslatedText text={'CG Notes'} />} />}
                            {type === 'edit' && <Box>
                                <Typography sx={{ opacity: '0.6', mb: 1 }} fontSize={17} ><TranslatedText text={'Groups that contain a contact'} />:</Typography>
                                <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: 2, pl: 2 }} >

                                    {
                                        contactGroupContacts.map((el: any) => (
                                            <Chip
                                                key={el.leadgroupid}
                                                label={el.leadgroupcode}
                                                // onClick={handleClick}
                                                onDelete={() => deleteContactFromGroup(el.id)}
                                                deleteIcon={<HighlightOffIcon color="error" />}
                                                variant="outlined"
                                            />
                                        ))

                                    }
                                    <Chip
                                        label={<TranslatedText text={'Add to group'} />}
                                        color="primary"
                                        onClick={handleMenuClick}
                                        icon={<AddCircleOutlineIcon />}
                                    />
                                    <Menu
                                        id="long-menu"
                                        MenuListProps={{
                                            'aria-labelledby': 'long-button',
                                        }}
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleMenuClose}

                                    >
                                        {contactGroups.map((el: any) => (
                                            <MenuItem key={el.id} onClick={() => handleAddContactToGroup(el.id)}>
                                                {el.leadgroupcode}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Box>
                            </Box>}
                            <Box sx={{ width: '100%', display: "flex", flexDirection: "column" }}>
                                <TextField key={contactData.additionalfields + '3'} sx={{ width: "100%", '& textarea': { resize: 'vertical' } }} defaultValue={contactData.additionalfields || ''}
                                    label={<TranslatedText text={"Additional fields (field=value, each on a new line)"} />}
                                    onBlur={(e) => setContactData({ ...contactData, additionalfields: e.target.value !== '' ? e.target.value : null })}
                                    multiline
                                    rows={4}
                                    fullWidth
                                    variant="outlined" />
                            </Box>
                            {type == 'edit' &&
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Channel for call"} /></InputLabel>
                                    <Select sx={{ width: "100%", mb: 2 }} labelId="simple-select-label" onChange={(e) => setContactData({ ...contactData, channel: e.target.value !== '' ? e.target.value : null })} value={contactData.channel || ''} variant="outlined" size="small" label={<TranslatedText text={"Channel for call"} />} >
                                        {channels.map((option: any) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>}
                            <Box sx={{ display: "flex", width: 940, justifyContent: "space-between", gap: 2 }}>


                                <Button onClick={() => type === "edit" ? putData(contactData) : postData(contactData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={'Save'} /></Button>
                                {/* On create redirect to contacts */}
                                {type !== 'edit' && snackbarType === 'success' && <Navigate to='/contacts' />}
                                {type == 'edit' &&
                                    <Button onClick={() => makeCall({
                                        ...contactData,
                                    })} variant="contained" color="success" sx={{ width: "100%" }}><TranslatedText text={'Run'} /></Button>}
                            </Box>
                        </Box>
                    </Box>
                    <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                        {snackbarType === 'error' ?
                            <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                                <TranslatedText text={'Saving error'} />
                            </Alert> :
                            <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                                <TranslatedText text={'Successfully saved'} />
                            </Alert>}
                    </Snackbar>
                    <Snackbar open={openCallSnackbar} autoHideDuration={6000} onClose={handleCloseCall}>
                        {snackbarType === 'error' ?
                            <Alert onClose={handleCloseCall} severity="error" sx={{ width: '100%' }}>
                                <TranslatedText text={'Error initializing call'} />
                            </Alert> :
                            <Alert onClose={handleCloseCall} severity="success" sx={{ width: '100%' }}>
                                <TranslatedText text={'Initializing a call'} />
                            </Alert>}
                    </Snackbar>
                </Box>
            }
        </>
    )
}